import Vue from 'vue'
import Router, { RouterView } from 'vue-router'
import store from '@/store'
// import Home from './views/Home.vue'

import LoginView from '@/Login.vue'
// import TestPage from './views/TestPage.vue'
// import SidebarCobaView from '@/TestLogo.vue'

import DashView from '@/Dash.vue'
import MarketInsight from './views/MarketInsight.vue'
import TradingChartView from './views/TradingChartView.vue'
import TradeView from './views/Trade.vue'
import EWarrantView from './views/E-Warrant.vue'
import TransferView from './views/Transfer.vue'
import ReportsView from './views/Reports.vue'
import NewsView from './views/News.vue'
import HelpView from './views/Help.vue'
import SettingsView from './views/Settings.vue'
import RrsView from './views/ReconcileReportingSystem.vue'
import UploadVideoView from './views/UploadVideo.vue'

import Pdf from './views/Pdf.vue'

Vue.use(Router)


const ifNotAuthenticated = (to, from, next) => {
	if (!store.getters.isAuthenticated) {
		next()
		return
	}
	next({ name: 'Trade' })
	return
}

const ifAuthenticated = (to, from, next) => {
	if (!store.getters.isAuthenticated) {
		localStorage.setItem('nextUrl', JSON.stringify(to))
		store.dispatch('AUTH_LOGOUT').then(() => {
			next({ name: 'Login' })
		})
		return
	}

	next()
	return
}

const beforeEnterAddBankAccount = (to, from, next) => {
	if (!store.state.bankAccount.requestKeyAddBankAccount) {
		next({ name: 'Add Bank Account' })
	} else {
		next()
	}
	// console.log('ROUTER', store.state.bankAccount.whichProcessAddBankAccount, to, from)
	// if (store.state.bankAccount.whichProcessAddBankAccount == 'add' && to.name != 'Add Bank Account') {
	// 	next({ name: 'Add Bank Account' })
	// } else if (store.state.bankAccount.whichProcessAddBankAccount == 'verify' && to.name != 'Identity Verification') {
	// 	next({ name: 'Identity Verification' })
	// } else if ((store.state.bankAccount.whichProcessAddBankAccount == 'photo' || store.getters.getAccountLevel['bankAccount/whichProcessAddBankAccount'] == 'otp') && to.name != 'Take Photo') {
	// 	next({ name: 'Take Photo' })
	// } else {
	// 	next()
	// }
}

// const ifAdmin = () => {
// 	if (true) {
// 		next()
// 		return
// 	}
// 	next({name: 'Trade'})
// }

const routes = [
	// {
	//	 path: '/',
	//	 name: 'home',
	//	 component: Home
	// },
	{
		path: '/login',
		name: 'Login',
		component: LoginView,
		beforeEnter: ifNotAuthenticated,
	},
	// {
	// 	path: '/test',
	// 	name: 'Test',
	// 	component: () => import('./views/NewPnl.vue'),
	// },
	{
		path: '/register',
		name: 'Register',
		component: () => import('./views/register/RegisterView.vue'),
		beforeEnter: ifNotAuthenticated,
	},
	{
		path: '/invoice',
		name: 'Invoice',
		component: Pdf,
		// beforeEnter: ifAuthenticated,
	},

	{
		path: '/redirect',
		name: 'Redirect',
		component: () => import('./views/RedirectPage.vue')
	},

	{
		path: '/',
		component: DashView,
		children: [
			// {

			// },
			// {
			// 	path: '/test',
			// 	name: 'Test Page',
			// 	component: TestPage
			// },
			{
				path: '/promo',
				name: 'Promo',
				component: () => import('./views/promo/Promo.vue')
			},

			{
				path: '/UploadVideo',
				name: 'Upload Video',
				component: UploadVideoView
			},
			{
				path: '/trade',
				alias: '/',
				name: 'Trade',
				component: TradeView
			},
			{
				path: '/e-warrant',
				name: 'E-Warrant',
				component: EWarrantView
			},
			{
				path: '/trading-chart',
				name: 'Trading Chart',
				component: TradingChartView
			},
			{
				path: '/transfer',
				name: 'Transfer',
				component: TransferView,
				meta: {
					pageName: 'Transfer'
				},
				beforeEnter: (to, from, next) => {
					if (store.getters.getAccountLevel == 'client' || store.getters.getAccountLevel == 'lp') {
						next()
						return
					} else {
						next(from)
						return
					}
				}
			},
			{
				path: 'withdrawal',
				component: {
					// Inline declaration of a component that renders our <router-view>
					render: (c) => c('router-view'),
				},
				meta: { breadcrumb: 'Withdrawal' },
				children: [
					{
						path: '',
						name: 'Withdrawal',
						component: () => import('./views/withdrawal/Withdrawal.vue'),
						meta: { developmentOnly: true },
					},
					{
						path: 'riwayat-withdrawal-tunai',
						name: 'Riwayat Withdrawal Tunai',
						component: () => import('./views/withdrawal/RiwayatWithdrawalTunai.vue'),
						meta: {
							breadcrumb: 'Riwayat Withdrawal',
							developmentOnly: true
						},
					},
					{
						path: 'riwayat-deposit',
						name: 'Riwayat Deposit',
						component: () => import('./views/withdrawal/RiwayatDeposit.vue'),
						meta: {
							breadcrumb: 'Riwayat Deposit',
							developmentOnly: true
						},
					},
					{
						path: '/add-bank-account',
						component: {
							render: (c) => c('router-view'),
						},
						meta: { breadcrumb: 'Tambah Rekening Bank' },
						children: [
							{
								path: '',
								name: 'Add Bank Account',
								component: () => import('./views/withdrawal/AddBankAccount.vue'),
								meta: {
									developmentOnly: true
								},
							},
							{
								path: 'identity-verification',
								component: {
									render: (c) => c('router-view'),
								},
								meta: { breadcrumb: 'Validasi Identitas' },
								children: [
									{
										path: '',
										name: 'Identity Verification',
										component: () => import('./views/withdrawal/IdentityValidation.vue'),
										meta: { developmentOnly: true },
										beforeEnter: beforeEnterAddBankAccount,
									},
									{
										path: '/add-bank-account/take-photo',
										name: 'Take Photo',
										component: () => import('./views/withdrawal/TakePhoto.vue'),
										meta: {
											breadcrumb: 'Foto Selfi',
											developmentOnly: true
										},
										// beforeEnter: beforeEnterAddBankAccount
									},
								]
							},
						],
					},
				]
			},
			{
				path: 'settings',
				component: {
					render: (c) => c('router-view'),
				},
				children: [
					{
						path: '',
						name: 'Settings',
						component: () => import('./views/Settings.vue'),
					},
					{
						path: 'rekening-penarikan',
						name: 'Rekening Penarikan',
						component: () => import('./views/settings/RekeningPenarikan.vue'),
						meta: { breadcrumb: 'Manage Account' }
					},
				]
			},
			{
				path: '/reports',
				name: 'Reports',
				component: ReportsView
			},
			{
				path: '/news',
				name: 'News',
				component: NewsView
			},
			{
				path: '/help',
				name: 'Help',
				component: HelpView
			},
			// {
			// 	path: '/settings',
			// 	name: 'Settings',
			// 	component: SettingsView
			// },
			{
				path: '/rrs',
				name: 'rrs',
				component: RrsView
			},
			{
				path: '/logout',
				name: 'Logout'
			},
			{
				path: '/marketinsight',
				name: 'Market Insight',
				component: MarketInsight
			},
			// {
			// 	path: '/:pathMatch(.*)*',
			// 	component: PageNotFound
			// },
		],
		beforeEnter: ifAuthenticated,
	}

	// {
	//	 path: '/about',
	//	 name: 'about',
	//	 // route level code-splitting
	//	 // this generates a separate chunk (about.[hash].js) for this route
	//	 // which is lazy-loaded when the route is visited.
	//	 component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
	// }
]

const router = new Router({
	mode: process.env.NODE_ENV == 'production' ? 'history' : 'hash', // 'history' or 'hash'. 'history' will remove '#' from url
	routes: routes
})

router.beforeEach((to, from, next) => {
	if (process.env.NODE_ENV == 'production' && to.meta.developmentOnly) {
		next({ name: 'Trade' })
	} else {
		next()
	}
})

export default router
